module.exports = __webpack_public_path__ + "static/img/7.0a44e7f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/sp/7.png
// module id = 53+m
// module chunks = 0